import { Component } from 'react';
import { Table, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';

import { SideBar } from '../../components/SideBar';
import { ButtonLink } from '../../components/Button';
import { Title } from '../../components/Typography';

import { api } from '../../utils/api';
import { getUser } from '../../selectors/user';
import { AppState } from '../../reducers';
import { UserState } from '../../reducers/user';
import { IWarranty } from '../../reducers/warranties';

import classes from './warranty.module.scss';

interface Props {
  user: UserState;
}

interface State {
  fetching: boolean;
  error: boolean;
  data: IWarranty[];
}

class Warranty_ extends Component<Props, State> {
  state = {
    fetching: true,
    error: false,
    data: [],
  };

  componentDidMount() {
    return this.fetchWarranties();
  }

  async fetchWarranties() {
    const { user } = this.props;

    try {
      const { data } = await api.get(`/user/${user.data!.id}/warranties`, {
        Authorization: `Bearer ${user.data!.token}`,
      });

      this.setState({ data });
    } catch {
      this.setState({ error: true });
    } finally {
      this.setState({ fetching: false });
    }
  }

  render() {
    const { fetching, data } = this.state;

    return (
      <div className={classes.warranty}>
        <SideBar>
          <ButtonLink to={'new'}>Registra prodotto</ButtonLink>

          <div className={classes.warranties}>
            <Title as={'h3'}>I miei prodotti</Title>

            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Codice</th>
                  <th>Data di acquisto</th>
                </tr>
              </thead>
              <tbody>
                {data.map((warranty: IWarranty) => (
                  <tr key={warranty.id}>
                    <td>{warranty.id}</td>
                    <td>{warranty.codice_prodotto}</td>
                    <td>{warranty.data_acquisto}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {fetching && (
              <Spinner animation={'border'} role={'status'}>
                <span className={'sr-only'}>Loading...</span>
              </Spinner>
            )}
          </div>
        </SideBar>
      </div>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  user: getUser(state),
});

export const Warranty = connect(mapStateToProps)(Warranty_);
